import { Component, OnInit, signal, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';

import {
  StateService,
  ToolService,
  RouterService,
  ConstructionSite,
  FileTreeComponent,
  NodeItem,
  ConstructionSiteState,
  UploadModalComponent,
} from 'projects/shared/src/public-api';
import { ContextMenuOption } from '../models/context-menu-option';
import { ModalController, Platform } from '@ionic/angular';
import { UploadItem } from '../models/upload-item';

@Component({
  selector: 'lib-construction-sites',
  templateUrl: './construction-sites.component.html',
  styleUrls: ['./construction-sites.component.scss'],
  standalone: false,
})
export class ConstructionSitesComponent implements OnInit {
  sub: Subscription;
  conSite: ConstructionSite;
  selectedNodeItem: NodeItem;
  detailsOpened: boolean = true;
  @ViewChild(FileTreeComponent) child!: FileTreeComponent;
  currentFolder = signal<NodeItem>({});
  selectedNodeItems: NodeItem[] = [];

  constructor(
    public state: StateService,
    public tools: ToolService,
    public routerService: RouterService,
    private platform: Platform,
    private modalController: ModalController
  ) {}

  currentFolderNodeItemChanged(item: NodeItem) {
    this.selectedNodeItem = item;
    this.currentFolder.update((n) => item);
  }

  selectedNodeItemsChanged(items: NodeItem[]) {
    this.selectedNodeItems = items;
  }

  ngOnInit() {
    this.sub = this.state.selectedConSite$.subscribe((x) => (this.conSite = x));
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  openPhone(phone: string) {
    window.open(`tel:${phone}`, '_system');
  }

  openMail(mail: string) {
    window.open(`mailto:${mail}`, '_system');
  }

  async openFile(id: string) {
    await this.state.openFile(id, 'document');
  }

  async openContextMenu(event: MouseEvent) {
    let additionalOptions: ContextMenuOption[] = [
      { icon: 'map-outline', label: 'Adresse öffnen', value: 'maps' },
    ];

    if (this.conSite.phone1)
      additionalOptions.push({
        icon: 'call-outline',
        label: this.conSite.contactName1
          ? this.conSite.contactName1 + ' anrufen'
          : this.conSite.phone1,
        value: 'call1',
      });
    if (this.conSite.email1)
      additionalOptions.push({
        icon: 'mail-outline',
        label: 'Email an ' + this.conSite.email1,
        value: 'mail1',
      });
    if (this.conSite.phone2)
      additionalOptions.push({
        icon: 'call-outline',
        label: this.conSite.contactName2
          ? this.conSite.contactName2 + ' anrufen'
          : this.conSite.phone2,
        value: 'call2',
      });
    if (this.conSite.email2)
      additionalOptions.push({
        icon: 'mail-outline',
        label: 'Email an ' + this.conSite.email2,
        value: 'mail2',
      });
    const { data, role } = await this.state.openPopover(
      event,
      true,
      additionalOptions
    );
    console.log('Popover dismissed with role:', role, 'and data:', data);
    switch (data) {
      case 'edit': {
        this.state.openConstructionSiteAlert(this.conSite);
        break;
      }
      case 'delete': {
        await this.state.deleteConstructionSite(this.conSite.id);
        break;
      }
      case 'call1': {
        this.openPhone(this.conSite.phone1);
        break;
      }
      case 'call2': {
        this.openPhone(this.conSite.phone2);
        break;
      }
      case 'mail1': {
        this.openMail(this.conSite.email1);
        break;
      }
      case 'mail2': {
        this.openMail(this.conSite.email2);
        break;
      }
      case 'maps': {
        this.openMap();
        break;
      }
    }
  }

  openMap() {
    const query = encodeURIComponent(
      this.conSite.address +
        ', ' +
        this.conSite.postalCode +
        ' ' +
        this.conSite.city
    );
    this.tools.openMap(query);
  }

  goBack() {
    this.child.goBack();
  }

  archiveConSites() {
    this.state.changeConstructionSiteStates(
      this.child.selectedNodeItems.map((x) => x.constructionSiteId),
      ConstructionSiteState.$1
    );
    this.child.unselectAll();
  }

  activateConSites() {
    this.state.changeConstructionSiteStates(
      this.child.selectedNodeItems.map((x) => x.constructionSiteId),
      ConstructionSiteState.$0
    );
    this.child.unselectAll();
  }

  openFileInput() {
    document.getElementById('file').click();
  }

  async fileInput(files: FileList) {
    const modal = await this.modalController.create({
      component: UploadModalComponent,
      backdropDismiss: false,
      componentProps: {
        fileList: files,
        currentFolder: this.currentFolder,
      },
    });
    modal.present();
    const { data, role } = await modal.onWillDismiss();
  }
}
